





































import { Component, Vue, Prop } from 'vue-property-decorator';
import PageHeaderError from '@/components/PageHeaderError.vue';
import SvgErrorIcon from '@/components/SvgErrorIcon.vue';
import ColorButton from '@/components/ColorButton.vue';
import { OsType, getOSType } from '@/util/device';

@Component({
  components: {
    PageHeaderError,
    SvgErrorIcon,
    ColorButton
  }
})
export default class Page extends Vue {
  private get url(): string {
    return this.$store.getters['auth/requestURL'];
  }

  mounted(): void {
    window.addEventListener('copy', this.handleCopy);
  }

  beforeDestroy(): void {
    window.removeEventListener('copy', this.handleCopy);
  }

  private onCopy(): void {
    const field: HTMLDivElement = this.$el
      .getElementsByClassName('error-page-contents-hidden')
      .item(0) as HTMLDivElement;

    const range: Range = document.createRange();
    const selection: Selection | null = window.getSelection();
    range.selectNode(field);
    selection && selection.removeAllRanges();
    selection && selection.addRange(range);
    document.execCommand('Copy');
    selection && selection.removeAllRanges();
  }

  private handleCopy(): void {
    const selection: Selection | null = window.getSelection();
    if (selection === null) return;
    var copied = selection.toString();
    if (copied.trim() !== this.url) return;

    this.$buefy.toast.open({
      message: this.$tc('componentsUnsupportView.copied'),
      type: 'is-info',
      position: 'is-bottom'
    });
  }
}
